import About from "../components/About"


const AboutPage = (p) => {
    

    return <About dimensions={ p.dimensions} />
}

export default AboutPage;